import { API } from "./api";
import { convertScanner, Scanner } from "./scanner";

export interface Log {
  id: number;
  content: string;
  createdAt: Date;
  scanner: Scanner;
}

export const convertLog = (l: API.Log): Log => {
  return {
    id: l.id,
    content: l.content,
    createdAt: new Date(l.created_at),
    scanner: convertScanner(l.scanner),
  }
}

export const convertLogs = (l: API.Log[]): Log[] => {
  return l.map(convertLog)
}

export interface LogFilter {
  scanner?: number
}
